// HM-310.r cluster 15 visual rework: wrapper layout reception aggiornato
// alla nuova API AppLayout (hotel + user.role in sidebar UserCard, no
// onProfile, no avatar dropdown topbar).

import { AppLayout } from '@hotel-manager/ui';
import { useQuery } from '@tanstack/react-query';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { logout as logoutApi } from '../api/auth.js';
import { getCurrentTenant } from '../api/tenant.js';
import { sidebarItems } from '../sidebar-items.js';
import { useAuth } from '../stores/auth.js';

export function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuth((s) => s.user);
  const logoutClient = useAuth((s) => s.logout);

  // HM-552 multi-hotel: fetcha tenant corrente per anagrafica dinamica
  // in sidebar (al posto dell'hardcoded "Hotel Mik · Nola, NA").
  const tenantQuery = useQuery({
    queryKey: ['tenant', 'me'],
    queryFn: getCurrentTenant,
    staleTime: 5 * 60_000,
    enabled: !!user,
  });

  const activeItemId =
    sidebarItems.find((it) => location.pathname.startsWith(it.href))?.id ?? 'dashboard';

  // HM-389 cluster login PIN: preferiamo displayName (per operatori PIN)
  // con fallback email-prefix per backward compat con account legacy senza
  // username/displayName popolati.
  const userName = user?.displayName ?? user?.email?.split('@')[0] ?? '—';

  const tenantName = tenantQuery.data?.tenant.name ?? 'Hotel';
  const tenantLocation = (() => {
    const t = tenantQuery.data?.tenant;
    if (!t) return '';
    if (t.city && t.province) return `${t.city}, ${t.province}`;
    return t.city ?? t.province ?? '';
  })();

  return (
    <AppLayout
      hotel={{ name: tenantName, location: tenantLocation }}
      user={{ name: userName, role: user?.role }}
      sidebarItems={sidebarItems}
      activeItemId={activeItemId}
      onItemSelect={(id) => {
        const target = sidebarItems.find((it) => it.id === id);
        if (target) navigate(target.href);
      }}
      onLogout={async () => {
        // HM-389 cluster login PIN: conferma esplicita prima del logout
        // (richiesta dal mockup v2 "Vuoi uscire? La sessione corrente verra'
        // chiusa"). Usa native window.confirm per minimal footprint; un modal
        // pixel-aware lo aggiungeremo se cluster 25 polish lo richiede.
        const ok =
          typeof window !== 'undefined'
            ? window.confirm('Vuoi uscire? La sessione corrente verra chiusa.')
            : true;
        if (!ok) return;
        try {
          await logoutApi();
        } catch {
          // best effort: anche se l'API fallisce, ripuliamo lo stato client
        }
        logoutClient();
        navigate('/login', { replace: true });
      }}
    >
      <Outlet />
    </AppLayout>
  );
}
